import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  setAmount(event) {
    const amount = event.currentTarget.dataset.amount
    if (!amount || !this.hasInputTarget) return

    this.inputTarget.value = amount
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.inputTarget.focus()
  }
}
